var map = {
	"../assignment-pvd/assignment-pvd.module.ngfactory": [
		"yjOB",
		0,
		1,
		6,
		12
	],
	"../assignment-swh/assignment-swh.module.ngfactory": [
		"H+C6",
		0,
		1,
		6,
		15
	],
	"../assignments/assignments.module.ngfactory": [
		"NK3w",
		0,
		1,
		2,
		4,
		16
	],
	"../control-centre/control-centre.module.ngfactory": [
		"2uxY",
		0,
		1,
		2,
		5,
		13
	],
	"../partner-inductions/partner-inductions.module.ngfactory": [
		"/2NV",
		0,
		1,
		2,
		18
	],
	"../people/people.module.ngfactory": [
		"aTZV",
		0,
		2,
		7,
		19
	],
	"./modules/admin/admin.module.ngfactory": [
		"OWMv",
		0,
		1,
		2,
		4,
		5,
		7,
		14
	],
	"./modules/client/client.module.ngfactory": [
		"+sFt",
		0,
		1,
		2,
		4,
		17
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;